type UserData = {
  firstName?: string;
  lastName?: string;
};

export function fullName({ firstName, lastName }: UserData = {}): string {
  const first = firstName || '';
  const last = lastName || '';
  return `${first} ${last}`.trim();
}

export function shortName({ firstName, lastName }: UserData): string {
  const initials = firstName ? `${firstName[0]}.` : '';
  const last = lastName || '';
  return `${initials} ${last}`.trim();
}